import React from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import Icon from '../app_components/Icon';
import { usesDashFormVariant } from '../../utils/formVariant';
import { iconColorForTone } from './morphismIconColors';

const MorphDateInput = React.forwardRef(({ value, onClick, onChange, className }, ref) => (
  <input
    ref={ref}
    value={value}
    onClick={onClick}
    onChange={onChange}
    className={className || 'lex-input__control'}
    readOnly
  />
));

class DateInput extends React.Component {
  constructor(props) {
    super(props);
    this.updateDate = this.updateDate.bind(this);
  }

  updateDate(value) {
    this.props.onChange(value);
  }

  render() {
    const {
      label,
      value,
      inputError = '',
      minDate,
      maxDate,
      showYearDropdown,
      showMonthDropdown,
      tone = 'green',
      hint,
      morphism = true,
      variant,
    } = this.props;

    const selectedDate =
      value instanceof Date && !Number.isNaN(value.getTime())
        ? value
        : null;

    let boundedSelectedDate = selectedDate;
    if (boundedSelectedDate && minDate && boundedSelectedDate < minDate) {
      boundedSelectedDate = minDate;
    }
    if (boundedSelectedDate && maxDate && boundedSelectedDate > maxDate) {
      boundedSelectedDate = maxDate;
    }

    const picker = (
      <DatePicker
        customInput={
          morphism ? (
            <MorphDateInput className={usesDashFormVariant(variant) ? 'lex-dash-field__input' : undefined} />
          ) : undefined
        }
        className={morphism ? undefined : 'input_standard'}
        selected={boundedSelectedDate}
        onChange={(date) => this.updateDate(date)}
        dateFormat="MMMM d, yyyy"
        minDate={minDate}
        maxDate={maxDate}
        showYearDropdown={showYearDropdown || false}
        showMonthDropdown={showMonthDropdown || false}
      />
    );

    if (usesDashFormVariant(variant)) {
      return (
        <div className="lex-dash-field lex-dash-field--teal">
          {label && <label className="lex-dash-field__label">{label}</label>}
          <div className="lex-dash-field__inputWrap lex-dash-field__picker">
            {picker}
            <span className="lex-dash-field__icon" aria-hidden="true">
              <Icon name="calendar" size={16} color="#14B8A6" solid />
            </span>
          </div>
          {hint && <p className="lex-dash-field__hint">{hint}</p>}
          {inputError.length > 0 && <p className="lex-dash-field__error">{inputError}</p>}
        </div>
      );
    }

    if (!morphism) {
      return (
        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
          {label && <p className="label_standard">{label}</p>}
          {inputError.length > 0 && <p className="input_error">{inputError}</p>}
          {picker}
        </div>
      );
    }

    return (
      <div className="lex-field">
        {label && <p className="lex-field__label">{label}</p>}
        {hint && <p className="lex-field__hint">{hint}</p>}
        {inputError.length > 0 && <p className="lex-field__error">{inputError}</p>}
        <div className={`lex-input lex-input--${tone}`}>
          <span className="lex-input__icon" aria-hidden="true">
            <Icon name="schedule" size={18} color={iconColorForTone(tone)} />
          </span>
          {picker}
        </div>
      </div>
    );
  }
}

export default DateInput;
